import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { Container, Col, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import Loader from "../../components/shared/Loader";
const AchivmentShow = ({ match }) => {
	const [loading, setLoading] = useState(false);
	const {
		params: { centerID },
	} = match;
	const history = useHistory();

	const auth = useSelector(state => state.auth.user);
	const [AchivmentData, setAchivmentData] = useState({});
	const [dataLoaded, setDataLoaded] = useState(false);
	const dispatch = useDispatch();

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل الانجاز",
				breadcrumb: "الانجازات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(
				`${process.env.REACT_APP_API_URL}pages/achievements/sections/${centerID}`,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				setAchivmentData(response.data.data.section ?? {});
				setLoading(false);
				setDataLoaded(true);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};
	useEffect(() => {
		onStart();
	}, []);

	const HandleSubmit = e => {
		e.preventDefault();
		if (
			!AchivmentData?.titleObj?.ar ||
			!AchivmentData?.titleObj?.en ||
			!AchivmentData?.value
		)
			return;
		axios
			.put(
				`${process.env.REACT_APP_API_URL}pages/achievements/sections/${centerID}`,
				{
					section: { ...AchivmentData, title: AchivmentData.titleObj.ar },
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				history.push("/achivment/index");
				toast.success("تم اضافة الانجاز بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				console.log(error);
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div style={{ width: "100%" }}>
				<Container>
					<Row>
						<Col>
							<Container
								style={{
									display: "flex",
									justifyContent: "flex-start",
									alignItems: "flex-start",
									flexDirection: "column",
									gap: "2rem",
								}}
							>
								<Row style={{ width: "100%" }}>
									<Col>
										<div className="form-item">
											<input
												type="text"
												name=""
												id="AchivmentNameAR"
												value={AchivmentData?.titleObj?.ar ?? ""}
												placeholder="ادخل اسم الانجاز"
												onChange={e =>
													setAchivmentData({
														...AchivmentData,
														titleObj: {
															...AchivmentData.titleObj,
															ar: e.target.value,
														},
													})
												}
											/>
										</div>
									</Col>
								</Row>
								<Row style={{ width: "100%" }}>
									<Col>
										<div className="form-item">
											<input
												type="text"
												name=""
												id="AchivmentNameEn"
												value={AchivmentData?.titleObj?.en ?? ""}
												placeholder="ادخل اسم الانجاز بالانجليزية"
												onChange={e =>
													setAchivmentData({
														...AchivmentData,
														titleObj: {
															...AchivmentData.titleObj,
															en: e.target.value,
														},
													})
												}
											/>
										</div>
									</Col>
								</Row>
								<Row style={{ width: "100%" }}>
									<Col>
										<div
											style={{
												display: "flex",
												justifyContent: "flex-start",
												alignItems: "flex-start",
												flexDirection: "column",
											}}
										>
											<div className="form-item" style={{ width: "100%" }}>
												<input
													type="search"
													name="Count"
													id="otherInfo"
													value={AchivmentData?.value ?? ""}
													onChange={e =>
														e.target.value.length < 10 && Number(e.target.value)
															? setAchivmentData({
																	...AchivmentData,
																	value: e.target.value,
															  })
															: e.target.value === ""
															? e.target.value
															: (e.target.value =
																	"الرجاء ادخال البيانات بشكل صحيح")
													}
													placeholder="الرجاء ادخل معلومة رقمية عن الانجاز"
													style={{ width: "100%" }}
												/>
												<label htmlFor="otherInfo" style={{ fontSize: "12px" }}>
													{" "}
													<span style={{ color: "red" }}>*</span> المعلومة
													الرقمية عن الانجاز
												</label>
											</div>
										</div>
									</Col>
								</Row>
							</Container>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="form-item mt-3" onClick={HandleSubmit}>
								<button className="bt bt-success btn-block">ارسال</button>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		</section>
	);
};

export default AchivmentShow;
